<template>
  <v-card
    height="180"
    class="rounded-lg"
  >
    <v-card-text v-if="loading">
      <div class="d-flex justify-center align-center my-12">
        <v-progress-circular
          indeterminate
          size="50"
        />
      </div>
    </v-card-text>
    <v-card-text
      v-else-if="player && player.id"
      class="fill-height"
    >
      <v-row
        class="fill-height"
        no-gutters
      >
        <v-col cols="auto">
          <div class="d-flex flex-column justify-space-between align-center fill-height">
            <v-avatar
              size="100"
              class="elevation-2"
            >
              <v-img
                v-if="player.photo_url"
                :src="player.photo_url"
                width="100px"
                height="100px"
                class="rounded"
              />
              <v-icon
                v-else
                large
              >
                fal fa-user
              </v-icon>
            </v-avatar>
            <div class="caption grey--text d-flex flex-column align-center" />
            <div
              v-if="player.diagnosticStats.tsa"
              class="font-weight-bold pb-1"
              :style="{color: getColorFromValue(player.diagnosticStats.tsa.norm_super_comp_value, 100)}"
            >
              {{ player.diagnosticStats.tsa.norm_super_comp_value }}%
            </div>
          </div>
        </v-col>
        <v-col class="pl-4">
          <div class="d-flex fill-height flex-column justify-space-between">
            <div>
              <div class="d-flex align-center title grey--text text--darken-4">
                {{ player.name }}
                <country-flag
                  v-if="player.nationality"
                  :country="player.nationality"
                  rounded
                  class="ma-0"
                />
              </div>
              <div class="text-body-1 grey--text mt-1">
                {{ player.email }}
              </div>
              <div class="text-body-1 grey--text mt-1">
                {{ $t("individual_analysis.data.age") }}: {{ playerAge }}
              </div>
              <div class="text-body-1 grey--text mt-1">
                {{ $t("individual_analysis.data.team") }}: {{ player.team.name }}
                <span
                  v-if="player.player_positions && player.player_positions.length"
                  class="ml-3"
                >
                  {{ $t("individual_analysis.data.position") }}:
                  <v-chip
                    v-for="position in player.player_positions.slice(0, 3)"
                    :key="player.id + position.id"
                    x-small
                    label
                    class="mx-1"
                    color="primary"
                  >
                    {{ position.short_name }}
                  </v-chip>
                </span>
              </div>
              <div
                v-if="player.rank || player.country_code"
                class="text-body-1 grey--text d-flex align-center mt-1"
              >
                {{ $t("individual_analysis.data.competition") }}:
                <span
                  v-if="player.rank"
                  class="ml-1"
                >
                  {{ $t(`rank.${toCamelCase(player.rank.name)}`) }}
                </span>
                <span
                  v-if="player.rank && player.country_code"
                  class="mx-1"
                >
                  &middot;
                </span>
                <span v-if="player.country_code">
                  {{ countries().find(country => country.code === player.country_code) ? countries().find(country => country.code === player.country_code).name : '' }}
                </span>
              </div>
            </div>
            <v-progress-linear
              v-if="player.diagnosticStats.tsa"
              :color="getColorFromValue(player.diagnosticStats.tsa.norm_super_comp_value, 100)"
              height="25px"
              :indeterminate="loading"
              :value="player.diagnosticStats.tsa.norm_super_comp_value"
              rounded
            />
          </div>
        </v-col>
        <v-col cols="auto">
          <v-btn
            icon
            small
            color="primary"
            @click="$emit('selectPlayer')"
          >
            <v-icon small>
              fal fa-arrows-rotate
            </v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-text
      v-else
      class="grey--text d-flex flex-column align-center fill-height justify-center clickable"
      @click="$emit('selectPlayer')"
    >
      <div class="mb-4">
        <v-icon
          large
          color="grey lighten-1"
        >
          fal fa-circle-plus
        </v-icon>
      </div>

      <div>{{ $t("select_player.dialog.header") }}</div>
    </v-card-text>
  </v-card>
</template>

<script>

import { getColorForValue, toCamelCase } from '@/utils/helpers'
import { countries } from '@/data/models/Countries'

export default {
  name: 'PlayerSelectionCard',
  components: {
  },
  props: {
    player: {
      type: Object,
      default: () => ({})
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
  }),
  computed: {
    playerAge() {
      if (!this.player.birth_date) return ''

      return this.$dayjs().diff(this.$dayjs(this.player.birth_date), 'year')
    },
    gender() {
      return this.player.gender === 'male' ? this.$t('select.data.gender.male') : this.$t('select.data.gender.male')
    }
  },
  watch: {

  },
  mounted() {

  },
  methods: {
    toCamelCase,
    countries() {
      return countries
    },
    getColorFromValue(value, max, reverse = false) {
      return getColorForValue(value, max, reverse)
    }
  }
}
</script>
